export class AffinityGroup {
    public affinityGroupType: AffinityGroupType;
    public publicId: string;
    public displayName: string;
}

export class AffinityGroupType {
    public code: string;
    public description: string;
}
